export function errorNotify(error, notify) {

  let data = error.response.data;

  if (data.errors) {
    let k = 0;
    Object.keys(data.errors).forEach((item) => {
      let err = data.errors[item];
      k++;
      for (let i = 0; i < err.length; i++) {
        setTimeout(() => {
          notify({
            title: 'Ошибка',
            message: err[i],
            icon: "ti-alert",
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'warning'
          });
        }, 100 * k);
      }
    });
  }

  else if (data.message) {

    notify({
      title: 'Ошибка',
      message: data.message,
      icon: "ti-alert",
      horizontalAlign: 'right',
      verticalAlign: 'top',
      type: 'warning'
    });

  }
}

export function setTag(model, method, item) {
  this.$loading(true);
  this.loading = true;

  this.$http
    ({
      url: model,
      method: method,
      data: item
    })
    .then((response) => {
      if (method === 'POST') {
        this.val.push(item)
      }
      this.$emit('input', this.val);
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
      return null;
    })
    .finally(() => {
      setTimeout(() => {
        this.$loading(false);
        this.loading = false;
      }, 400);
    });
}

export function cardContent(model = '', id = null, contentType = 'single', params = {}) {
  this.$loading(true);
  return this.$http
    .get(model, {
      params: {
        ...params,
        id: id,
      },
    })
    .then((response) => {
      if (contentType === 'single')
        return multiKeyInit(response.data, this);
      else if (contentType === 'list')
        return multiKeysInit(response.data, this);
      else if (contentType === 'page')
        return multiKeysInit(response.data.data, this);
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
    })
    .finally(() => {
      setTimeout(() => {
        this.$loading(false);
      }, 400);
    });
}

export function cardUpdate(model = '', item = {}, method = 'put') {
  this.$loading(true);
  return this.$http
    ({
      url: model,
      method: method,
      data: item
    })
    .then((response) => {
      this.$store.dispatch("setLastUpdate", new Date());
      this.$notify({
        title: "Данные",
        message: "Данные успешно применились",
        icon: "ti-save",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success",
      });
      if (response.data) {
        return response.data;
      }
      return null;
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
      return null;
    })
    .finally(() => {
      setTimeout(() => {
        this.$loading(false);
      }, 400);
    });
}

export function multiKeysInit(items = [], app) {
  if (app.fields && app.fields.length) {
    if (items.length) {
      for (let i = 0; i < items.length; i++) {
        items[i] = multiKeyInit(items[i], app, i);
      }
    } else {
      multiKeyInit({}, app, 0);
    }
  }
  return items;
}

export function multiKeyInit(item = {}, app, count = 0) {

  if (app.fields && app.fields.length) {
    Object.keys(app.$store.state.languages).forEach((lang) => {
      let translationObject = {};
      if (item.translations) {
        translationObject = item.translations.find((obj) => {
          return obj.locale === lang;
        });
      }
      Object.keys(app.fields).forEach((key) => {

        let type = null;

        if (app.fields[key].type === 'field' || app.fields[key].type === 'textarea') {
          type = '';
        }
        else if (app.fields[key].type === 'checkbox') {
          type = false;
        }
        else if (app.fields[key].type === 'selects') {
          type = [];
        }
        else if (app.fields[key].type === 'select') {
          type = null;
        }
        else if (app.fields[key].type === 'html') {
          type = '';
        }
        else if (app.fields[key].type === 'object') {
          // console.log(app.fields[key].subFields);
          if (app.fields[key].subFields && app.fields[key].subFields.length) {
            type = {};
            for (let i = 0; i < app.fields[key].subFields.length; i++) {
              type[app.fields[key].subFields[i].key] = null
            }
          }

        }

        if (app.fields[key].isMultiLang === true) {
          if (count === 0) {
            app.fields.push({
              key: app.fields[key].key + ":" + lang,
              label: app.fields[key].label + " (" + lang + ")",
              type: app.fields[key].type,
              col: app.fields[key].col,
              textType: app.fields[key].textType,
              langKey: lang,
            });
          }

          item[app.fields[key].key + ":" + lang] =
            translationObject && translationObject[app.fields[key].key]
              ? translationObject[app.fields[key].key]
              : type;
        }
        else if (!item[app.fields[key].key]) {
          item[app.fields[key].key] = type;
        }
      });

    });
  }
  return item;
}

export function moveIndex(arr, old_index, new_index) {
  while (old_index < 0) {
    old_index += arr.length;
  }
  while (new_index < 0) {
    new_index += arr.length;
  }
  if (new_index >= arr.length) {
    var k = new_index - arr.length;
    while ((k--) + 1) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);

  return arr;
}